import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "toast-container-component",
  class: "toast-container position-fixed top-0 end-0 p-3",
  style: {"z-index":"11"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      id: "toast-template",
      class: "toast align-items-center text-white border-0 hide",
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, [
      _createElementVNode("div", { class: "toast-body" })
    ], -1)
  ])))
}